import { BROKER_CHARGES_DATA, BROKER_CHARGES_ERROR_DATA, BROKER_CHARGES_HIDE_ERROR_DATA, BROKER_CHARGES_START_LOADER, BROKER_CHARGES_STOP_LOADER, } from "../interface/IBrokerCharges";
const initState = {
    data: {
        brokerage: "",
        clearingCharge: "",
        gst: "",
        sebiTurnoverCharge: "",
        stampDutyCharge: "",
        stt: "",
        totalCharge: "",
        transactionCharge: "",
        turnover: "",
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const brokerCharges = (state = initState, action) => {
    switch (action.type) {
        case BROKER_CHARGES_DATA: {
            return Object.assign(Object.assign({}, state), { data: action.payload.brokerCharges });
        }
        case BROKER_CHARGES_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case BROKER_CHARGES_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case BROKER_CHARGES_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case BROKER_CHARGES_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default brokerCharges;
